import React from 'react';
import { DynamicList, Icon, IconType } from '@repo/ui/components';
import { IContractTypeList, IGetServiceContract } from 'sales-types-common';
import { IDynamicListConfig, IDynamicListColumn, cn } from 'types';

export const getHeaderPriceConfig = (contractTypeList: IContractTypeList[]): IDynamicListColumn[] => {
  let priceConfigHeader: IDynamicListColumn[] = [
    {
      header: 'Beskrivelse',
      key: 'coveringInfo',
      colWidth: '1fr',
      noSort: true,
      cellClassName: 'text-base/[175%] font-semibold',
    },
  ];
  contractTypeList?.map((item) =>
    priceConfigHeader.push({
      header: item.name,
      key: 'header_' + item?.id,
      colWidth: '14rem',
      noSort: true,
      headerClassName: 'flex items-center justify-center',
      cellClassName: 'flex items-center justify-center',
    })
  );
  return priceConfigHeader;
};

export const CompareIcon = (props: any) => {
  const item = props.serviceContract.contractTypeCoveringList.filter(
    (listItem) =>
      listItem.coveringInfoId === props.coveringListItem.id && listItem.contractTypeId === props.contractTypeId
  );

  return (
    <Icon
      icon={item.length ? IconType.NewNextCheckFilled : IconType.NewNextCancelSolid}
      fill={item.length ? 'var(--color-komorebi)' : 'var(--color-neutralPlus)'}
      width={24}
      height={24}
    />
  );
};

export interface IAgreementComparisionListProps {
  serviceContract?: IGetServiceContract;
  className?: string;
}

export const AgreementsComparisonList = (props: IAgreementComparisionListProps) => {
  const dynamicColumns = getHeaderPriceConfig(props?.serviceContract?.contractTypeList)?.slice(1);

  const getAgreementComparisonData = () => {
    let rowDataObj = {};
    return props.serviceContract?.coveringInformationList?.map((listItem) => {
      dynamicColumns?.map((header) => {
        const rowData = (
          <CompareIcon
            serviceContract={props.serviceContract}
            coveringListItem={listItem}
            contractTypeId={+header?.key?.split('_')?.[1]}
          />
        );
        rowDataObj[`${header.key}`] = rowData;
      });
      return {
        ...listItem,
        ...rowDataObj,
      };
    });
  };

  const getComparisonTableConfig = (contractTypeList): IDynamicListConfig => {
    return {
      cols: getHeaderPriceConfig(contractTypeList),
    };
  };

  return (
    <div className={cn('w-full p-6 max-h-[calc(100vh_-_16.8rem)] overflow-auto', props?.className)}>
      <DynamicList
        data={getAgreementComparisonData()}
        config={getComparisonTableConfig(props?.serviceContract?.contractTypeList)}
        EmptyComponent={() => (
          <div className="bg-white py-3 px-6 rounded-b-lg">
            <span className="text-base/[175%] font-semibold">
              Servicekontrakter er ikke tilgjengelig for denne modellen
            </span>
          </div>
        )}
        className="w-full overflow-auto"
      />
    </div>
  );
};

export default AgreementsComparisonList;
